<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadUser="loadUser"
      @loadSummary="loadSummary"
      @loadTable="loadTable"
      :includeAdmin="true"
    ></results-bar>
    <results-summary
      v-if="viewMode === 'summary'"
      :id="doc.id"
      :model="model"
      :lang="lang"
      :key="keyCounter"
    ></results-summary>
    <results-table
      v-if="viewMode === 'table'"
      :id="doc.id"
      :model="model"
      :lang="lang"
      :key="keyCounter"
    ></results-table>
  </div>
</template>

<script>
import {
  ResultsBar,
  ResultsSummary,
  ResultsTable,
} from "@/components/results/attributes";

export default {
  name: "AttributesResults",
  props: {
    doc: {
      type: Object,
      default: null,
    },
    model: String,
    lang: String,
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
      viewMode: "summary",
      keyCounter: 0,
    };
  },
  components: {
    ResultsSummary,
    ResultsBar,
    ResultsTable,
  },
  methods: {
    loadSummary() {
      this.currentUser = null;
      this.viewMode = "summary";
      this.keyCounter++;
    },
    loadTable() {
      this.currentUser = null;
      this.viewMode = "table";
      this.keyCounter++;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.viewMode = "user";
      this.keyCounter++;
    },
  },
};
</script>
